<template>
  <nav class="gl-step-bar gl-breadcrumb breadcrumb has-arrow-separator is-medium">
    <ul>
      <li>
        <a href="/shop/cart">
            <span class="icon is-small">
              <icon name="shopping-cart" scale="1" class="el-icon-fa"/>
            </span>
          <span>Корзина</span>
        </a>
      </li>

      <template v-for="(step, index) in steps">
        <li :class="[{'is-active': currStepIndex === index}]">
          <a @click="moveToStep(index)">
            <span class="icon is-small">
               <icon :name="step.icon" scale="1" class="el-icon-fa"/>
            </span>
            <span>{{step.label}}</span>
          </a>
        </li>
      </template>
    </ul>
  </nav>
</template>

<script>
  export default {
    name: 'steps-bar',

    props: {
      steps: {
        type: Array,
        required: true
      },
      currStepIndex: {
        type: Number,
        required: true
      }
    },

    methods: {
      moveToStep (index) {
        if (index > this.currStepIndex) {
          return
        }

        this.$emit('select', index)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~bulma/bulma.sass';

  .gl-step-bar {
    .is-active a {
      color: $primary !important;
    }
  }
</style>



// WEBPACK FOOTER //
// StepsBar.vue?997cd490